import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import {
    BaasicFieldDropdown,
    BaasicModal,    
    BaasicFormControls,
    BaasicButton,
    ApplicationEmptyState,
    BasicInput
} from 'core/components';
import {PageFooter, EditFormLayout} from 'core/layouts';
import {UserPasswordChange} from 'application/user/pages';
import {UserEditPartialForm} from 'application/user/components';

function UserEditTemplate({ userEditViewStore, t }) {
    const {
        form,
        openMailPasswordReset,
        openChangePassword,
        toggleLock,
        toggleApprove,
        item,
        roleMultiselectStore,
        changePasswordModal,
        rootStore,
        loaderStore
    } = userEditViewStore;
    
    return (
        <EditFormLayout store={userEditViewStore} emptyRenderer={<ApplicationEmptyState />} loading={loaderStore.loading}>
            <div className="row">
                <div className="col col-sml-12 col-lrg-8">
                    <div className="card card--form card--primary card--med u-mar--bottom--med">
                        <h3 className="u-mar--bottom--med">General Data</h3>
                        <UserEditPartialForm form={form} />
                        <div className="row">
                            <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                <BasicInput field={form.$('userName')}/>
                            </div>
                            <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                <BaasicFieldDropdown field={form.$('roles')} store={roleMultiselectStore} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col col-sml-12 col-lrg-4">
                    <div className="card card--form card--primary card--med u-mar--bottom--med">
                        <h3 className="u-mar--bottom--med">Actions</h3> 
                            <ul>
                                <li className="u-mar--bottom--sml">
                                    <a onClick={openMailPasswordReset}><span className="u-icon u-icon--sml form__icon form__icon--email-pass u-mar--right--tny" /> Send password reset mail</a>
                                </li>
                                <li className="u-mar--bottom--sml">
                                    <a onClick={openChangePassword}><span className="u-icon u-icon--sml form__icon form__icon--reset-pass u-mar--right--tny" /> Change Password</a>
                                </li>
                            {item && <React.Fragment>
                                <li className="u-mar--bottom--sml">
                                    <a onClick={toggleApprove}>{item.isApproved ? <span><span className="u-icon u-icon--sml form__icon form__icon--approved u-mar--right--tny" /><span> Disapprove</span></span> : <span><span className="u-icon u-icon--sml form__icon form__icon--unapproved u-mar--right--tny"></span><span> Approve</span></span>}</a>
                                </li>
                                <li className="u-mar--bottom--sml">
                                    <a onClick={toggleLock}>{item.isLockedOut ? <span><span className="u-icon u-icon--sml form__icon form__icon--unlocked u-mar--right--tny" /><span> Unlock</span></span> : <span><span className="u-icon u-icon--sml form__icon form__icon--unlocked u-mar--right--tny"></span><span> Lock</span></span>}</a>
                                </li>
                                </React.Fragment>}
                            </ul>

                    </div>
                </div>
            </div>
            
            <BaasicModal modalParams={changePasswordModal} className="modal__content modal--sml">
                <UserPasswordChange/>
            </BaasicModal>

            {renderEditLayoutFooterContent({
                form,
                t,
                goBack: () => rootStore.routerStore.goBack()
            })}
        </EditFormLayout>
    )
}

UserEditTemplate.propTypes = {
    userEditViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

function renderEditLayoutFooterContent({ form, goBack, t }) {
    return <PageFooter>
                <BaasicFormControls form={form} onSubmit={form.onSubmit}/>
                <BaasicButton
                    className="btn btn--base btn--ghost"
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={goBack}
                />
            </PageFooter>
}

renderEditLayoutFooterContent.propTypes = {
    form: PropTypes.any,
    goBack: PropTypes.func,
    t: PropTypes.func
};

export default defaultTemplate(UserEditTemplate);
